const shiftAdd = (lastValue: number, newValue: number, bits: number) =>
  lastValue * Math.pow(2, bits) + newValue;

const parseBits = function (data: DataView, bits: number, offset: number) {
  const offsetBytes = offset >> 3;

  // read first (maybe partial) byte
  let mask = 0xff;
  let firstBits = 8 - (offset % 8);
  if (bits < firstBits) {
    mask = (0xff << (8 - bits)) & 0xff;
    firstBits = bits;
  }

  if (offset) {
    mask = mask >> offset % 8;
  }

  let result = 0;
  if ((offset % 8) + bits >= 8) {
    result = shiftAdd(0, data.getUint8(offsetBytes) & mask, firstBits);
  }

  // read bytes
  const bytes = (bits + offset) >> 3;
  for (let i = offsetBytes + 1; i < bytes; i++) {
    result = shiftAdd(result, data.getUint8(i), 8);
  }

  // bits to read, that are not a complete byte
  const lastBits = (bits + offset) % 8;
  if (lastBits > 0) {
    result = shiftAdd(result, data.getUint8(bytes) >> (8 - lastBits), lastBits);
  }

  return result;
};

const decoder = new TextDecoder('utf-8');

const textParser = (dv: DataView) => decoder.decode(dv);

export const arrayParser = function (value: DataView) {
  const dim = parseBits(value, 32, 0);

  // const flags = parseBits(value, 32, 32);
  const elementType = parseBits(value, 32, 64);

  let offset = 96;
  const dims = [];
  for (let i = 0; i < dim; i++) {
    // parse dimension
    dims[i] = parseBits(value, 32, offset);
    offset += 32;

    // ignore lower bounds
    offset += 32;
  }

  const parseElement = function (elementType: number) {
    // parse content length
    const length = parseBits(value, 32, offset);
    offset += 32;

    // parse null values
    if (length == 0xffffffff) {
      return null;
    }

    let result;
    if (elementType == 0x17 || elementType == 0x14) {
      // int/bigint
      result = parseBits(value, length * 8, offset);
      offset += length * 8;
      return result;
    } else if (elementType == 0x19) {
      // string
      result = textParser(
        new DataView(
          value.buffer,
          value.byteOffset + (offset >> 3),
          (offset += length << 3) >> 3,
        ),
      );
      return result;
    } else {
      throw new Error('ERROR: ElementType not implemented: ' + elementType);
    }
  };

  type ValueOrArray = null | number | string | ValueOrArray[];

  const parser = function (dimension: number[], elementType: number) {
    const array: ValueOrArray[] = [];
    let i;

    if (dimension.length > 1) {
      const count = dimension.shift()!;
      for (i = 0; i < count; i++) {
        array[i] = parser(dimension, elementType);
      }
      dimension.unshift(count);
    } else {
      for (i = 0; i < dimension[0]; i++) {
        array[i] = parseElement(elementType);
      }
    }

    return array;
  };

  return parser(dims, elementType);
};
